export default __webpack_public_path__ + "assets/hilldale.e11f875d.png";